/* eslint-disable */
var Flickity = require('flickity');
require('flickity-imagesloaded');
require('flickity-as-nav-for');
require('flickity-fade');

jQuery( function( $ ) {

	if ( 0 < $( '.flickity-go' ).length ) {
		$.each( $( '.flickity-go' ), ( key, value ) => {
			new Flickity(
				value, {
					prevNextButtons: false,
					pageDots: true,
					draggable: true,
					freeScroll: false,
					imagesLoaded: true,
					watchCSS: true,
					groupCells: 1,
					wrapAround: true,
					touchVerticalScroll: false,
					adaptiveHeight: true,
				}
			);
		});
	}

	if ( 0 < $( '.flickity-go--arrows' ).length ) {
		$.each( $( '.flickity-go--arrows' ), ( key, value ) => {
			new Flickity(
				value, {
					prevNextButtons: true,
					pageDots: true,
					draggable: true,
					freeScroll: false,
					imagesLoaded: true,
					watchCSS: true,
					groupCells: 3,
					wrapAround: true,
					cellAlign: 'left',
					touchVerticalScroll: false,
					arrowShape: 'M1.06 48l-.06.09A3.44 3.44 0 0 0 1.06 53l31.6 31.4a3.55 3.55 0 0 0 5 0 3.6 3.6 0 0 0 0-5L12.16 54h84.3a3.54 3.54 0 1 0 0-7.08H12.15L37.7 21.49a3.54 3.54 0 0 0-5-5z',
				}
			);
		});
	}

	if ( 0 < $( '.flickity-go--no-group' ).length ) {
		$.each( $( '.flickity-go--no-group' ), ( key, value ) => {
			new Flickity(
				value, {
					prevNextButtons: true,
					pageDots: true,
					draggable: true,
					freeScroll: false,
					imagesLoaded: true,
					watchCSS: true,
					groupCells: true,
					wrapAround: false,
					touchVerticalScroll: false,
					arrowShape: 'M1.06 48l-.06.09A3.44 3.44 0 0 0 1.06 53l31.6 31.4a3.55 3.55 0 0 0 5 0 3.6 3.6 0 0 0 0-5L12.16 54h84.3a3.54 3.54 0 1 0 0-7.08H12.15L37.7 21.49a3.54 3.54 0 0 0-5-5z',
				}
			);
		});
	}

	if (0 < $(".hero-carousel__main").length) {
		$.each($(".hero-carousel__main"), (key, value) => {
			new Flickity(value, {
				autoPlay: 10000,
				pageDots: true,
				wrapAround: true,
				lazyLoad: 1,
				pauseAutoPlayOnHover: false,
				draggable: true,
			});
		});
	}

	if (0 < $(".hero-carousel__nav").length) {
		$.each($(".hero-carousel__nav"), (key, value) => {
			new Flickity(value, {
				asNavFor: ".hero-carousel__main",
				cellAlign: "center",
				contain: true,
				pageDots: false,
				wrapAround: true,
				fade: true,
				pauseAutoPlayOnHover: false,
				draggable: false,
			});
		});
	}

	if (0 < $(".video-image-slider__inner").length) {
		$.each($(".video-image-slider__inner"), (key, value) => {
			new Flickity(value, {
				prevNextButtons: false,
				pageDots: true,
				draggable: true,
				imagesLoaded: true,
				contain: true,
				freeScroll: false,
				wrapAround: true,
				cellSelector: '.video-image-slider__slide',
			}).on( 'change', function() {
				// get all video iframes that are not selected
				const iframes = document.querySelectorAll( '.video-image-slider__slide--video:not(.is-selected) iframe' );

				// pause command for vimeo
				const pause = {
					"method": "pause",
					"value": "true"
				};

				// pause all videos when selected slide is changed.
				iframes.forEach( iframe => {
					iframe.contentWindow.postMessage( JSON.stringify( pause ), "*" );
				});
			});
		});
	}
});
